import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { MyHttpClient } from '../http-client';

export interface VehicleModelItem {
  _id?: string;
  model: string;
  manufacturer: string;
  displayName?: string;
  modeId?: string;
}

export interface VehicleModelsResponse {
  items: VehicleModelItem[];
  total: number;
  limit: number;
  offset: number;
}

@Injectable()
export class VehicleModelsService {
  private readonly baseUrl = process.env.SERVER + '/api/get/vehicleModel';

  constructor(private http: MyHttpClient) {}

  fetchVehicleModels(modeId: string, limit: number, offset: number, bodyType?: string, active?: string | boolean): Observable<VehicleModelsResponse> {
    const parts: string[] = [];
    if (modeId) parts.push(`modeId=${encodeURIComponent(modeId)}`);
    if (typeof bodyType === 'string' && bodyType.trim().length) parts.push(`bodyType=${encodeURIComponent(bodyType.trim())}`);
    if (typeof active !== 'undefined' && active !== null && String(active).length) parts.push(`active=${encodeURIComponent(String(active))}`);
    if (Number.isFinite(limit)) parts.push(`limit=${limit}`);
    if (Number.isFinite(offset)) parts.push(`offset=${offset}`);

    const params = parts.join('&');
    const url = params ? `${this.baseUrl}?${params}` : this.baseUrl;

    return this.http.get<any>(url).map((res: any) => {
      const items: VehicleModelItem[] = (res && Array.isArray(res.items)) ? res.items : [];
      const total: number = (res && typeof res.total !== 'undefined') ? Number(res.total) : items.length;
      return { items, total, limit, offset } as VehicleModelsResponse;
    });
  }

  updateVehicleModel(id: string, payload: { manufacturer: string; model: string; displayName: string; active?: boolean }): Observable<any> {
    const url = `${process.env.SERVER}/api/update/vehicleModel/${encodeURIComponent(id)}`;
    return this.routedPut(url, payload);
  }

  createVehicleModel(payload: {
    manufacturer: string;
    model: string;
    displayName: string;
    modeId: string;
    active: boolean;
    bodyType?: string;
  }): Observable<any> {
    const url = `${process.env.SERVER}/api/create/vehicleModel`;
    return this.http.post(url, payload);
  }

  private routedPut(url: string, body: any): Observable<any> {
    return this.http.put(url, body);
  }
}
